import React, { useState } from 'react';
import { ProductRequestResult, ProductRequestResultProduct, SearchRequest } from '../../../../../Services/SearchProductFeedTypes';
import { ShopifyProductCollection } from '../../../../../Services/ShopifyManualSortingServices';
import { PanelBody } from '../../../../../Components/Panel/Panel';
import { EmptyState } from '../../../../../Components/EmptyState/EmptyState';
import Btn from '../../../../../Components/Btn';
import ShopifyManualSortingPanelBody from './ShopifyManualSortingPanelBody';
import ShopifyManualSortingProductPositionSelector from './ShopifyManualSortingProductPositionSelector';
import { PinnedShopifyProduct, ShopifyCollectionWithPinnedProducts } from './ShopifyManualSortingTypes';
import { NameLabel } from '../../../Ranking/context/RankingContextProvider';
import { ShopifyCollectionPinnedProductsServiceType } from '../../../Ranking/services/ShopifyCollectionPinnedProductsService';

type ShopifyManualSortingPanelType = {
	typeCategoriesSecondLevelSelected: NameLabel | undefined,
	selectedCategoryIsShopifyCollection: { isPinnableShopifyCollection: boolean, collectionId?: string },
	searchTerm: string,
	searchTermForInput: string,
	handleAutocompleteChange,
	searchProducts: (search: SearchRequest, callbackSuccess: ((data: ProductRequestResult) => void), callbackError?: ((error: string) => void)) => void,
	searchProductsByTerm: (callbackSuccess: ((data: ProductRequestResult) => void), callbackError?: ((error: string) => void)) => void,
	shopifyCollectionWithPinnedProducts: ShopifyCollectionWithPinnedProducts[] | undefined,
	shopifyCollectionPinnedProductsService: ShopifyCollectionPinnedProductsServiceType,
	shopifyCollections: ShopifyProductCollection[] | undefined,
	hasRetrievedNoShopifyCollection: boolean,
	hasCollisionWithTransformations: (item: PinnedShopifyProduct) => { hasEror: boolean, message?: string | null }[]
}

export default function ShopifyManualSortingPanel({
	typeCategoriesSecondLevelSelected,
	selectedCategoryIsShopifyCollection,
	searchTerm,
	searchTermForInput,
	searchProductsByTerm,
	handleAutocompleteChange,
	searchProducts,
	shopifyCollections,
	hasRetrievedNoShopifyCollection,
	shopifyCollectionWithPinnedProducts,
	shopifyCollectionPinnedProductsService,
	hasCollisionWithTransformations
}: ShopifyManualSortingPanelType) {

	const [showSelectorPopin, setShowSelectorPopin] = useState<{
		show: boolean,
		edit?: { collectionId: string, product: PinnedShopifyProduct },
		addSearchProduct?: ProductRequestResultProduct
	}
	>({ show: false });


	const handleEditProductPosition = (collectionId: string, selectedProduct: PinnedShopifyProduct) => {
		setShowSelectorPopin({ show: true, edit: { collectionId, product: selectedProduct } });
	};

	const empty = () =>
		<PanelBody position='relative'>
			<EmptyState
				title={'Manually pin products in collections'}
				verticalAlign={true}
				primaryAction={
					<Btn
						onClick={() => setShowSelectorPopin({ show: true })}
						icon="fas fa-plus-circle"
						message="Pin product"
						color="primary"
						style='reverse'
					/>
				}
			/>
		</PanelBody>;

	const body = () =>
		<ShopifyManualSortingPanelBody
			collectionWithPinnedProducts={shopifyCollectionWithPinnedProducts ?? []}
			shopifyCollections={shopifyCollections}
			searchTerm={searchTerm}
			searchTermForInput={searchTermForInput}
			searchProductsByTerm={searchProductsByTerm}
			handleAutocompleteChange={handleAutocompleteChange}
			handleAdd={() => setShowSelectorPopin({ show: true })}
			handleDeleteAll={shopifyCollectionPinnedProductsService.handleDeleteAll}
			handleDeleteProductPosition={shopifyCollectionPinnedProductsService.handleDeleteProductPosition}
			handleEditProductPosition={handleEditProductPosition}
			handleAddSearchProduct={p => setShowSelectorPopin({ show: true, addSearchProduct: p })}
			hasCollisionWithTransformations={hasCollisionWithTransformations}
		/>;

	const productSelector = () =>
		<ShopifyManualSortingProductPositionSelector
			showPopin={showSelectorPopin}
			handleClose={() => setShowSelectorPopin({ show: false })}
			shopifyCollections={shopifyCollections || []}
			collectionWithPinnedProducts={shopifyCollectionWithPinnedProducts ?? []}
			handleConfirm={shopifyCollectionPinnedProductsService.handleAddProductPosition}
			searchProducts={searchProducts}
			typeCategoriesSecondLevelSelected={typeCategoriesSecondLevelSelected}
			selectedCategoryIsShopifyCollection={selectedCategoryIsShopifyCollection}
		/>;

	if (shopifyCollectionWithPinnedProducts === undefined)
		return <div>loading</div>;

	if (hasRetrievedNoShopifyCollection)
		return <div>no Shopify Collection</div>;

	return (<>
		{productSelector()}
		{shopifyCollectionWithPinnedProducts.length === 0 && empty()}
		{shopifyCollectionWithPinnedProducts.length > 0 && body()}
	</>);
}
